import { ProductMatrix } from '../../models/product-matrix.model';
import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Injectable()
export default class ProductMatrixHelper {
    //#region Mapping Analysis

    static mapProductMatrixToTree(products: ProductMatrix[]): TreeNode[] {
        return ProductMatrixHelper.getProductDescendants(products);
    }

    static getProductDescendants(products: ProductMatrix[]): TreeNode[] {
        const productTree: TreeNode[] = [];
        products?.forEach(p => {
            const productNode: TreeNode = {
                label: p.productName, data: p.productCode,
                children: this.getProductDescendants(p.descendants)
            };
            productTree.push(productNode);
        });
        return productTree;
    }

    static getProductMatrixCodes(productMatrices: ProductMatrix[]) {
        const productCodes: string[] = [];
        productMatrices?.forEach(p => {
            productCodes.push(p.productCode);
            if (p.descendants?.length > 0) {
                productCodes.push(...this.getProductMatrixCodes(p.descendants));
            }
        });
        return productCodes;
    }

    static getProductMatrixNames(productMatrices: ProductMatrix[]) {
        const productNames: string[] = [];
        productMatrices?.forEach(p => {
            productNames.push(p.productName);
            if (p.descendants?.length > 0) {
                productNames.push(...this.getProductMatrixNames(p.descendants));
            }
        });
        return productNames;
    }
}
